import React from 'react'
import styled from 'styled-components'

import { Text, Button } from '../UI'

const SSizes = styled.div`
    padding: .5rem 1rem;
    display: grid;
    grid-template-rows: 1rem 3rem;
    grid-gap: .5rem;
    @media only screen and (max-width: 600px) {
        grid-template-rows: 100%;
        grid-template-columns: min-content auto;
    }
`

const SGridContainer = styled.div`
    overflow-x: auto;
    overflow-y: hidden;
`

const SGrid = styled.div`
    display: grid;
    grid-auto-flow: column;
    grid-gap: .5rem;
`

export default function Sizes(props: { options: string[], clickHandler: (key: string) => void, selected: string }) {

    return (
        <SSizes>
            <Text primary bold>Size</Text>
            <SGridContainer>
                <SGrid>
                    {props.options.map(key => <Button
                        key={key}
                        onClick={() => props.clickHandler(key)}
                        style={{
                            opacity: props.selected === key ? 1 : 0.5
                        }}
                    >
                        {key}
                    </Button>)}
                </SGrid>
            </SGridContainer>
        </SSizes>
    )
}
